module.exports = __webpack_public_path__ + "img/none_comm_png@2x.e4f326eb.png";